module.exports = __webpack_public_path__ + "media/three.88a46390.mp3";